import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ComboBox, MenuHeader, MenuSeparator } from '@skbkontur/react-ui';
import { ValidationWrapper } from '@skbkontur/react-ui-validations';
import { employeeTids } from '../../../../constants/tids';
import { FieldWrapper } from '../../../FieldWrapper';
import { ComboBoxItem } from './components/ComboBoxRow';
import { ComboBoxValue } from './components/ComboBoxValue';
import { convertDocumentsTypes, convertDocumentTypeToString, getDocumentTypeCode, getPopularDocumentTypes, searchDocumentsTypes, } from './DocumentTypeField.helpers';
export const DocumentTypeField = ({ validationInfo, onValueChange, documentsList, menuAlign, value, disabled, labelClassName, }) => {
    const documentRows = useMemo(() => {
        return convertDocumentsTypes(documentsList);
    }, [documentsList]);
    const comboBoxValue = useMemo(() => {
        if (!value?.code && !value?.name) {
            return null;
        }
        return {
            description: '',
            code: value.code,
            name: value.name,
        };
    }, [value]);
    const handleValueChange = (item) => {
        onValueChange({ code: item.code, name: item.name });
    };
    const handleUnexpectedInput = (query) => {
        return { code: query, name: '' };
    };
    const getItems = async (query) => {
        const items = searchDocumentsTypes({ items: documentRows, query });
        if (items.length === 0) {
            return [];
        }
        let rows = [...items];
        const popularDocumentTypes = getPopularDocumentTypes(documentRows);
        if (popularDocumentTypes.length > 0 && !query) {
            rows = [
                _jsx(MenuHeader, { children: "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435" }, "popular"),
                ...popularDocumentTypes,
                _jsx(MenuSeparator, {}, "separator"),
                _jsx(MenuHeader, { children: "\u0412\u0441\u0435" }, "\u0412\u0441\u0435"),
                ...rows,
            ];
        }
        return rows;
    };
    return (_jsx(FieldWrapper, { label: "\u0412\u0438\u0434 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430", labelClassName: labelClassName, children: _jsx(ValidationWrapper, { validationInfo: validationInfo, children: _jsx(ComboBox, { width: 348, getItems: getItems, value: comboBoxValue, menuAlign: menuAlign, onValueChange: handleValueChange, itemToValue: getDocumentTypeCode, placeholder: "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0432\u0432\u043E\u0434\u0438\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0438\u043B\u0438 \u043A\u043E\u0434", onUnexpectedInput: handleUnexpectedInput, "data-tid": employeeTids.documentTypeInput, valueToString: convertDocumentTypeToString, renderValue: (item) => _jsx(ComboBoxValue, { item: item }), renderItem: (item) => _jsx(ComboBoxItem, { item: item }), disabled: disabled }) }) }));
};
